import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { AiChat } from '../AiChat';
import { CommentSystem } from '../CommentSystem';
import { Icon } from '@iconify/react';
export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);
  const [commentMode, setCommentMode] = useState(false);
  const [commentPanelOpen, setCommentPanelOpen] = useState(false);
  const [pageCommentCount, setPageCommentCount] = useState(0);
  return <div className="min-h-screen bg-gray-bg font-sans relative" data-id="element-204">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} aiModeActive={aiChatOpen} onAiModeToggle={() => setAiChatOpen(!aiChatOpen)} data-id="element-205" />
      <Header onMenuClick={() => setSidebarOpen(true)} commentMode={commentMode} onCommentModeToggle={() => setCommentMode(!commentMode)} commentCount={pageCommentCount} onCommentPanelToggle={() => setCommentPanelOpen(!commentPanelOpen)} data-id="element-206" />
      <main className="pl-0 md:pl-[260px] pt-16 min-h-screen" data-id="element-207">
        <div className="p-4 md:p-8 max-w-[1600px] mx-auto" data-id="element-208">
          <CommentSystem commentMode={commentMode} panelOpen={commentPanelOpen} onPanelClose={() => setCommentPanelOpen(false)} onCommentModeOff={() => setCommentMode(false)} onPageCommentCount={setPageCommentCount} data-id="element-209">
            <Outlet data-id="element-210" />
          </CommentSystem>
        </div>
      </main>

      {/* AI Chat Overlay */}
      <AiChat isOpen={aiChatOpen} onClose={() => setAiChatOpen(false)} data-id="element-211" />
    </div>;
}